export default __webpack_public_path__ + "static/media/cevrihasandort5.4319991a.jpg";